
import josip from '../assets/imgs/josip_lopizic_vert.png';
import kalebic from '../assets/imgs/kalebic.png'
import tudor from '../assets/imgs/tudor.png'

export const greetings = {
    'josip-lopizic':{
        name:"Josip Lopižić",
        title:"mr. spec.",
        section_title:"Pozdravna riječ predsjednika Hrvatskog psihološkog društva",
        description:"Predsjednik Hrvatskog psihološkog društva",
        link:'/pozdravna-rijec/josip-lopizic',
        image: josip,
        image_vert:josip,
        text: "Poštovane kolegice, poštovani kolege,\n\n\
        Zadovoljstvo nam je pozvati vas na još jednu godišnju konferenciju hrvatskih psihologa s \
        međunarodnim sudjelovanjem koja će se po drugi put održati u Splitu, u Kongresnom centru Hotela \
        Radisson, od 5. do 8. studenoga 2025. godine. Središnja tema ove konferencije je \
        „Psihologija i psiholozi u kriznim vremenima: Jačanje otpornosti pojedinca, obitelji i zajednice”.\n\
        I na ovoj konferenciji, ponovno se bavimo mentalnim zdravljem s obzirom na brojne izazove i krize \
        s kojima se kao pojedinci i društvo svakodnevno susrećemo i suočavamo. Kakav je utjecaj svih tih izazova na naš svakodnevni život, \
        kako se s njima nosimo i koje su posljedice \
        koje kao pojedinci i zajednica proživljavamo samo su dio važnih pitanja na koje ćemo kroz različite oblike rada pokušati \
        odgovoriti na ovoj konferenciji. Ali, s obzirom na glavnu temu, stavit ćemo poseban naglasak i na naše resurse i \
        čimbenike otpornosti koji su važni za suočavanje \
        i uspješno nošenje te prevladavanje različitih kriznih situacija koje svakodnevno živimo.\n\
        Kao i na svakoj konferenciji, dobrodošli su i drugi sadržaji s kojima se kao struka bavimo i \
        koji nisu izravno povezani s glavnom temom konferencije. \
        Ova 32. godišnja konferencija, naš godišnji susret u Splitu, tradicionalno je izvrsna prilika \
        za susret kolegica i kolega, za nova učenja vezanima ponajprije za psihologijsku praksu ali i za upoznavanje s novim \
        područjima psihologijske djelatnosti i izazovima koji su pred nama. Konferencije su oduvijek bile \
        središnji godišnji skupovi psihologinja i psihologa te mjesta druženja i susreta kolega i prijatelja. Naši \
        ljubazni domaćini, Društvo psihologa Splitsko-dalmatinske županije najavljuju i vrlo lijepi društveni \
        program te brojne zanimljive sadržaje posebno vezane za Split, grad Marka Marulića koji, u svom književnom djelu, \
        prvi u svjetskim razmjerima, bilježi pojam – psihologija. \
        Dobrodošli u Split, dobrodošli na 32. godišnju konferenciju hrvatskih psihologa! \n\n\
        Josip Lopižić, predsjednik Hrvatskog psihološkog društva"
    },
    'katija-kalebic-jakupcevic':{
        name:"Katija Kalebić Jakupčević",
        title:"doc. dr. sc.",
        section_title:"Pozdravna riječ predsjednice Programskog odbora",
        description:"Predsjednica Programskog odbora",
        link:'/pozdravna-rijec/katija-kalebic-jakupcevic',
        image: kalebic,
        image_vert: kalebic,
        text:"Dobrodošli na konferenciju\
        „Psihologija i psiholozi u kriznim vremenima: jačanje otpornosti pojedinca, obitelji i \
        zajednice“!\n\n\
        Izuzetno nam je zadovoljstvo pozdraviti vas na još jednoj godišnjoj konferenciji koja, kao i do \
sada, okuplja stručnjake, istraživače i studente iz različitih područja psihologije. U vremenu \
kada se sve češće suočavamo s raznim izazovima i kriznim situacijama koje pogađaju svakog \
od nas, ova konferencija pruža priliku za razmjenu ideja, zajedničko razmišljanje i učenje o \
tome kako psihologija može pomoći u jačanju otpornosti pojedinca i zajednice.\n\n\
Psihologija, kao znanstvena i praktična disciplina, ima ključnu ulogu u razumijevanju i \
rješavanju brojnih kriznih situacija s kojima se svakodnevno susrećemo. Kroz predavanja, \
radionice i diskusije, nastojat ćemo razmotriti izazove koji oblikuju našu svakodnevnicu te \
razmijeniti znanja i iskustva koja nam mogu pomoći u pronalaženju odgovora na krizne \
situacije i njihov utjecaj na mentalno zdravlje. Poseban naglasak bit će na psihološkim \
čimbenicima otpornosti, obiteljskim resursima i mehanizmima suočavanja, kao i na ulozi \
pojedinca, obitelji i zajednice u prevladavanju teškoća.\n\n\
Konferencija se održava u Splitu, gradu koji ima bogatu povijest i tradiciju te koji je ujedno i \
važan centar razvoja znanstvenih i obrazovnih aktivnosti. Na konferenciji ćete imati priliku \
sudjelovati u stručnim raspravama, ali i uživati u jedinstvenoj atmosferi ovog mediteranskog grada.\n\n\
Ovo je također i prilika da zajedno sagledamo kako psihologija može odgovoriti na aktualnu \
globalnu krizu te na izazove s kojima se suočavamo u osobnom i profesionalnom životu. Naš \
cilj je pružiti prostor za konstruktivnu raspravu i razmjenu informacija i promišljanje o \
budućim istraživanjima u svrhu još boljeg razumijevanju ljudskog ponašanja u kriznim situacijama.\n\n\
Zahvaljujemo svim kolegama i sudionicima na njihovom angažmanu i nadamo se da će ovaj \
događaj biti polazište za daljnje suradnje te razvoj novih ideja.\n\n\
S poštovanjem,\n\n\
doc.dr.sc Katija Kalebić Jakupčević, predsjednica Programskog odbora"
    },
    'vesna-tudor-pavicic':{
        name:"Vesna Tudor Pavičić",
        title: "mag. psyh.",
        section_title:"Pozdravna riječ predsjednice Organizacijskog odbora",
        description:"Predsjednica Organizacijskog odbora",
        link:'/pozdravna-rijec/vesna-tudor-pavicic',
        image: tudor,
        image_vert: tudor,
        text:'Poštovane kolegice i kolege,\n\n\
        kako bi rekla naša poznata Dalmatinka Meri Cetinić u svojoj pjesmi „davno je davno bilo \
to….“ Bilo je to 2009. godine kada smo se sastali u Splitu na 17. godišnjoj konferenciji \
psihologa i evo nas ponovno zajedno u „centru svita“ nakon punih 16 godina. \
Čast mi je i zadovoljstvo pozdraviti vas u ime organizacijskog odbora.\n\
Ovaj događaj nije samo prilika za stručno usavršavanje, već i za osobno povezivanje i \
razmjenu ideja koje nas vode prema novim saznanjima u psihologiji. U Splitu, u srcu \
Dalmacije, okupljamo se na mjestu koje ima bogatu kulturnu i povijesnu baštinu, a želim \
posebno spomenuti Marka Marulića, velikog hrvatskog književnika i filozofa. Zašto baš \
njega? „Psichiologia de ratione animae humanae“ (1524?), ili „Psihologija ljudske duše“, \
njegovo je djelo po kojem, osim što ga nazivaju ocem hrvatske književnosti, nazivaju ga i \
ocem pojma „psihologija“. Bio je duboko zaljubljen u ljudsku prirodu i psihu. Marulić, poznat \
po svom angažmanu na promicanju ljudskih vrijednosti, svojim je djelom otvorio put \
razumijevanju ljudskih dubina, što čini temelj i našeg djelovanja.\n\
Nadamo se da će i nas ova konferencija dodatno motivirati da nastavimo razvijati psihološku \
struku i doprinositi društvu na najbolji mogući način.\n\n\
Ono što garantiramo je ljekovita blizina mora, nadomak hotela Radisson Blu Resort & Spa-u \
kojem će se odvijati konferencija, a nadamo se da će i neslužbeni dio programa biti bogat i \
pun događanja. Kaže jedan naš mudri i cijenjeni kolega, ništa se ne brinite, to će biti izvrsna \
konferencija!\n\n\
        Vesna Tudor Pavičić, predsjednica Organizacijskog odbora'
    }
    
}